import React, { useState } from 'react';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <footer className="bg-gray-800 text-white py-12" data-id="element-71">
      <div className="container mx-auto px-4" data-id="element-72">
        <div className="text-center text-gray-500 text-sm" data-id="element-73">
          <p data-id="element-74">
            © {new Date().getFullYear()} Crianza Bilingüe. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-75">
            <button onClick={() => setShowTerms(true)} className="hover:text-orange-400 bg-transparent border-none cursor-pointer text-gray-500 text-sm" data-id="element-76">
              Términos de Servicio
            </button>{' '}
            ·
            <button onClick={() => setShowPrivacy(true)} className="hover:text-orange-400 ml-4 bg-transparent border-none cursor-pointer text-gray-500 text-sm" data-id="element-77">
              Política de Privacidad
            </button>
          </p>
        </div>
      </div>
      {/* Terms of Service Modal */}
      {showTerms && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-78">
          <div className="bg-white text-gray-800 rounded-lg shadow-xl max-w-md w-full max-h-[80vh] overflow-y-auto" data-id="element-79">
            <div className="p-6" data-id="element-80">
              <div className="flex justify-between items-center mb-4" data-id="element-81">
                <h2 className="text-xl font-bold" data-id="element-82">Términos de Servicio</h2>
                <button onClick={() => setShowTerms(false)} className="text-gray-500 hover:text-gray-700" data-id="element-83">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-84">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-85" />
                  </svg>
                </button>
              </div>
              <div className="prose prose-sm" data-id="element-86">
                <h3 data-id="element-87">1. Aceptación de los Términos</h3>
                <p data-id="element-88">
                  Al acceder y utilizar nuestros servicios, usted acepta estos
                  términos y condiciones en su totalidad.
                </p>
                <h3 data-id="element-89">2. Política de Devolución</h3>
                <p data-id="element-90">
                  <strong data-id="element-91">
                    El tiempo máximo para solicitar una devolución es de 7 días
                  </strong>{' '}
                  a partir de la fecha de compra. Para solicitar una devolución,
                  debe contactarnos por correo electrónico con su recibo de
                  compra.
                </p>
                <h3 data-id="element-92">3. Uso del Contenido</h3>
                <p data-id="element-93">
                  Todo el contenido proporcionado es para uso personal. No está
                  permitida la redistribución, reproducción o venta del
                  contenido sin autorización explícita.
                </p>
                <h3 data-id="element-94">4. Limitación de Responsabilidad</h3>
                <p data-id="element-95">
                  No nos hacemos responsables por el mal uso de la información
                  proporcionada en nuestros productos. Los resultados pueden
                  variar según las circunstancias individuales.
                </p>
                <h3 data-id="element-96">5. Modificaciones</h3>
                <p data-id="element-97">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Los cambios entrarán en vigor
                  inmediatamente después de su publicación.
                </p>
              </div>
              <div className="mt-6 text-center" data-id="element-98">
                <button onClick={() => setShowTerms(false)} className="bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700 transition-colors" data-id="element-99">
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Privacy Policy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-100">
          <div className="bg-white text-gray-800 rounded-lg shadow-xl max-w-md w-full max-h-[80vh] overflow-y-auto" data-id="element-101">
            <div className="p-6" data-id="element-102">
              <div className="flex justify-between items-center mb-4" data-id="element-103">
                <h2 className="text-xl font-bold" data-id="element-104">Política de Privacidad</h2>
                <button onClick={() => setShowPrivacy(false)} className="text-gray-500 hover:text-gray-700" data-id="element-105">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-106">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-107" />
                  </svg>
                </button>
              </div>
              <div className="prose prose-sm" data-id="element-108">
                <h3 data-id="element-109">1. Información que Recopilamos</h3>
                <p data-id="element-110">
                  Recopilamos información personal como su nombre, dirección de
                  correo electrónico y detalles de pago cuando realiza una
                  compra.
                </p>
                <h3 data-id="element-111">2. Uso de la Información</h3>
                <p data-id="element-112">
                  Utilizamos su información para procesar pedidos, proporcionar
                  soporte al cliente y mejorar nuestros productos y servicios.
                </p>
                <h3 data-id="element-113">3. Protección de Datos</h3>
                <p data-id="element-114">
                  Implementamos medidas de seguridad para proteger su
                  información personal contra acceso no autorizado o
                  divulgación.
                </p>
                <h3 data-id="element-115">4. Devoluciones y Reembolsos</h3>
                <p data-id="element-116">
                  Al igual que en nuestros Términos de Servicio,{' '}
                  <strong data-id="element-117">ofrecemos un período de devolución de 7 días</strong>{' '}
                  para todos nuestros productos digitales. Para solicitar un
                  reembolso, contáctenos con su recibo de compra.
                </p>
                <h3 data-id="element-118">5. Cookies</h3>
                <p data-id="element-119">
                  Utilizamos cookies para mejorar su experiencia en nuestro
                  sitio web. Puede configurar su navegador para rechazar
                  cookies, pero esto puede afectar algunas funcionalidades.
                </p>
                
                
              </div>
              <div className="mt-6 text-center" data-id="element-120">
                <button onClick={() => setShowPrivacy(false)} className="bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700 transition-colors" data-id="element-121">
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>}
    </footer>;
}